/**
 * Trucking TMS driver profile options for service UI.
 */

export const DRIVER_FORM_SIZE = "sm";

export const CDL_CLASS_OPTIONS = [
  { label: "Class A", value: "A" },
  { label: "Class B", value: "B" },
  { label: "Class C", value: "C" },
];

export const CDL_ENDORSEMENT_OPTIONS = [
  { code: "H", label: "H - Hazardous Materials" },
  { code: "N", label: "N - Tank Vehicle" },
  { code: "P", label: "P - Passenger" },
  { code: "S", label: "S - School Bus" },
  { code: "T", label: "T - Double/Triple Trailers" },
  { code: "X", label: "X - Tank + Hazmat" },
];

export const DRIVER_PAY_TYPE_OPTIONS = [
  { label: "Company Driver", value: "company_driver" },
  { label: "Owner Operator", value: "owner_operator" },
  { label: "Lease Operator", value: "lease_operator" },
  { label: "Per Mile", value: "per_mile" },
  { label: "Hourly", value: "hourly" },
  { label: "Percentage of Load", value: "percentage" },
];

export const DRIVER_EMPLOYMENT_STATUS_OPTIONS = [
  { label: "Active", value: "active" },
  { label: "Leave of Absence", value: "leave" },
  { label: "Suspended", value: "suspended" },
  { label: "Terminated", value: "terminated" },
];

export const DRIVER_COMPLIANCE_STATUS_LABELS = {
  valid: "Compliant",
  expiring_soon: "Expiring Soon",
  expired: "Expired",
  missing: "Incomplete",
};

export const DRIVER_COMPLIANCE_STATUS_COLORS = {
  valid: "green",
  expiring_soon: "yellow",
  expired: "red",
  missing: "gray",
};

export const DRIVER_COMPLIANCE_FILTER_OPTIONS = [
  { label: "All compliance statuses", value: "" },
  { label: "Compliant", value: "valid" },
  { label: "Expiring soon", value: "expiring_soon" },
  { label: "Expired", value: "expired" },
  { label: "Incomplete", value: "missing" },
];

export const DRIVER_ASSIGNMENT_ENFORCEMENT_OPTIONS = [
  { label: "Off — no assignment checks", value: "off" },
  { label: "Warn — allow assign with toast", value: "warn" },
  { label: "Block — prevent non-compliant assign", value: "block" },
];

/** Default driver form fields including compliance + pay. */
export const DRIVER_PROFILE_DEFAULTS = {
  licenseNumber: "",
  licenseState: "",
  licenseType: "A",
  licenseExpiration: "",
  endorsements: [],
  medicalCertExpiration: "",
  hazmatCertified: false,
  hazmatCertExpiration: "",
  twicCertified: false,
  twicExpiration: "",
  yearsOfExperience: "",
  payType: "company_driver",
  employmentStatus: "active",
  homeTerminal: "",
  lastDrugTestDate: "",
  nextDrugTestDue: "",
  lastMvrDate: "",
  emergencyContactName: "",
  emergencyContactPhone: "",
  hourlyRate: "",
  mileageRate: "",
  emptyRate: "",
};
